import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Img } from 'containers/misc'
import { Button } from 'components/misc'
import styles from './logo-upload.styl'

export default class LogoUpload extends Component {
  static propTypes = {
    data: PropTypes.object,
    change: PropTypes.func.isRequired
  }
  static defaultProps = {
    data: {},
    files: {}
  }

  state = {
    logo: null,
    logoWillBeRemoved: false
  }

  handleLogoSelect = e => {
    const file = e.target.files[0]
    const reader = new FileReader()

    if (!file) {
      return
    }

    reader.onload = base64file => {
      this.setState({
        logo: base64file.target.result,
        logoWillBeRemoved: false
      })
      this.props.change('file', file)
    }
    reader.readAsDataURL(file)
  }

  handleRemoveLogo = () => {
    this.setState({
      logo: null,
      logoWillBeRemoved: true
    })
    this.props.change('file', null)
    this.props.change('logoUrl', null)
  }

  render() {
    const { data } = this.props
    const { logo, logoWillBeRemoved } = this.state

    const displayRemoveButton = Boolean(logo) || data.logoUrl

    return (
      <div className={styles.uploader}>
        {!logo &&
          !get(data, 'logoUrl') &&
          <div className={styles.placeholder}>LOGO</div>}
        {logo &&
          !logoWillBeRemoved &&
          <img className={styles.image} src={logo} />}
        {get(data, 'logoUrl') &&
          !logo &&
          !logoWillBeRemoved &&
          <Img className={styles.image} src={data.logoUrl} />}
        <input
          className={styles.picker}
          type="file"
          onChange={this.handleLogoSelect}
          accept="image/gif, image/jpeg, image/png"
        />
        {displayRemoveButton &&
          <Button
            type="button"
            intlKey="button.remove_photo"
            negative
            tiny
            className={styles.btn}
            onClick={this.handleRemoveLogo}
          >
            Remove
          </Button>}
      </div>
    )
  }
}
